import {ERequestType} from 'shared/types/requests';
import {IRpcResponse} from 'shared/types/rpc';
import {performRequest} from 'shared/utils';

import {IPostActionDataArgs, IPostUploadFileArgs} from '../model/types';

export const postUploadFile = (
    data: IPostUploadFileArgs,
) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(item => {
                formData.append(key, item);
            });
        } else {
            formData.append(key, value);
        }
    });

    return performRequest<Omit<IRpcResponse, 'processingResultList'>>({
        method: ERequestType.POST,
        url: '/table-reports/run-custom-action-with-file',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
    });
};

export const postActionData = (
    data: IPostActionDataArgs,
) => performRequest<Omit<IRpcResponse, 'processingResultList'>>({
    method: ERequestType.POST,
    url: '/table-reports/run-custom-action',
    data,
});
